/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getRecord'

export { $nsid }

/** Get data blocks needed to prove the existence or non-existence of record in the current version of repo. Does not require auth. */
const main = l.query(
  $nsid,
  l.params({
    did: l.string({ format: 'did' }),
    collection: l.string({ format: 'nsid' }),
    rkey: l.string({ format: 'record-key' }),
  }),
  l.payload('application/vnd.ipld.car'),
  [
    'RecordNotFound',
    'RepoNotFound',
    'RepoTakendown',
    'RepoSuspended',
    'RepoDeactivated',
  ],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
